










































import Vue from 'vue'
import { IDevice } from '@/types/model'
import { api } from '@/singleton'
import mixins from 'vue-typed-mixins'
import { slaveDeviceDialogMixin } from '@/mixins'
import easyapi from '@/easyapi'
import { EdidMode } from '@/types/api'
import RadioIcon from '@/components/RadioIcon.vue'
import DeviceRadioRow from '@/components/DeviceRadioRow.vue'

/**
 * manual: 1, 3, 4, 5, 6, 7, 8
 * learning: 2
 */
type ui_edid_type_t = 'manual' | 'learning'
export default mixins(slaveDeviceDialogMixin).extend({
  components: {
    RadioIcon,
    DeviceRadioRow
  },
  data (): {
    uiEdidType: ui_edid_type_t
    uiManualEdidEnum: EdidMode
    MANUAL_EDID_ENUMS: EdidMode[]
    EDID_MODE: typeof EdidMode
    uiLearnFromRx: IDevice | null
    // deviceNameFilterStr: string
  } {
    return {
      uiEdidType: 'manual',
      uiManualEdidEnum: EdidMode.default,
      EDID_MODE: EdidMode,
      MANUAL_EDID_ENUMS: [
        EdidMode.default,
        EdidMode._720P_LPCM,
        EdidMode._1080P_dolby,
        EdidMode._1080P_LPCM,
        EdidMode._3840x2160_dolby,
        EdidMode._3840x2160_LPCM,
        EdidMode._4096x2160_dolby
      ],
      uiLearnFromRx: null
      // deviceNameFilterStr: '',
    }
  },
  computed: {
    device (): IDevice | null { return this.dialog.device },
    learnFromList (): IDevice[] {
      if (!this.device) { return [] }
      const groupID = this.device.groupID
      return this.$s.$state.device.list.filter((x) => x.deviceType === 'RX' && x.groupID === groupID)
    },
    invalid (): boolean {
      if (this.uiEdidType === 'learning') {
        return !this.uiLearnFromRx
      } else {
        return false
      }
    }
  },
  methods: {
    async apply () {
      if (!this.device) { return }
      const tmp = {
        mac: this.device.mac,
        edidMode: EdidMode.default,
        learningEDIDFrom: ''
      }
      if (this.uiEdidType === 'learning') {
        if (!this.uiLearnFromRx) { throw new Error('[To Developer] this should never be happened') }
        tmp.edidMode = EdidMode.learningEDID
        tmp.learningEDIDFrom = this.uiLearnFromRx.mac
      } else {
        tmp.edidMode = this.uiManualEdidEnum
        tmp.learningEDIDFrom = ''
      }
      const ok = await easyapi.setEdid(this, tmp)
      if (ok) {
        this.closeThisDialog()
      }
    }
  },
  watch: {
    device (dev: IDevice | null) {
      if (dev) {
        if (dev.txInfo.edidMode === EdidMode.learningEDID) {
          this.uiEdidType = 'learning'
          this.uiLearnFromRx = this.$s.$state.device.list.find((d) => d.mac === dev.txInfo.learningEDIDFrom) || null
        } else {
          this.uiEdidType = 'manual'
          this.uiLearnFromRx = null
          this.uiManualEdidEnum = dev.txInfo.edidMode
        }
      }
    }
  }
})
